module["exports"] = [
  "0800 ### ###",
  "0800 ## ## ##",
  "0## ### ## ##",
  "0## ### ## ##",
  "+41 ## ### ## ##",
  "0900 ### ###",
  "076 ### ## ##",
  "+4178 ### ## ##",
  "0041 79 ### ## ##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/phone_number/formats.js
// module id = 321
// module chunks = 0